import styled from '@emotion/styled';
import React from 'react';

type Props = {
  isInverted?: boolean;
};

export const WaveRule = ({ isInverted = false }) => (
  <Wave isInverted={isInverted} />
);

const Wave = styled.div<Props>`
  background-image: url('https://d12xoj7p9moygp.cloudfront.net/images/homepage/wave.svg');
  background-color: #8940fa;
  height: 24px;
  transform: ${({ isInverted }: Props) => (isInverted ? 'rotate(180deg)' : '')};
  @media (max-width: 1024px) {
    height: 18px;
    background-size: contain;
  }
  @media (max-width: 420px) {
    height: 14px;
  }
`;
